/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  RequestStatus.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company      : Honeywell Technology Solutions , Hyderabad
 *
 * @Author      : Deepthi Bachu(E844276)
 *
 * @Date        : Mar 12, 2020
 *
 * @Version     : Version 1.0
 *
 * Modified
 * By            : 
 * On            :
 * Description   : 
 ******************************************************************************/

import React from 'react';
import { Modal, Button, Icon, Grid} from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import { getProperty } from 'utils/util';
import { CheckoutUILabels, CheckoutServiceURL } from '../constants/checkout-constants';

function handleClick(){
     window.location.href = getProperty(CheckoutServiceURL.ADS_DASHBOARD_URL);
}

function RequestStatus(props){
    return (
        <Modal
            size="large"
            open={true}
            className="selectAccountModal"
        >
            <Modal.Header>{CheckoutUILabels.ALERT_PENDING_HEADER}</Modal.Header>
            <Modal.Content>
                <Grid.Row>
                    <Grid.Column width={1}>
                        <Icon root="common" name="badge-info" size="xlarge" color="red"/>
                    </Grid.Column>
                    <Grid.Column width={11}>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <b>{CheckoutUILabels.ALERT_PENDING_MSG}</b>
                            </Grid.Column>
                        </Grid.Row>
                        <br/><br/>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                {"Your request " + props.match.params.sfdcCaseNo+" is being processed. "+CheckoutUILabels.ALERT_PENDING_DESC1}
                            </Grid.Column>
                        </Grid.Row>

                    </Grid.Column>
                </Grid.Row>
            </Modal.Content>
            <Modal.Footer>
                <div>       
                    <Button type="primary" size="medium" content="OK" className="co-primary-button"  
                            onClick={() => handleClick()}/>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default RequestStatus;